import l1 from './l-1'
import l2 from './l-2'
import l3 from './l-3'
import l4 from './l-4'
import l5 from './l-5'
import l6 from './l-6'
import l7 from './l-7'
import l8 from './l-8'
import l9 from './l-9'
import about from './about'
import completedGuest from './completed-Guest'
import completedUser from './completed-User'
import completedKompetansePluss from './completed-Kompetansepluss'

const modules = {
  'l-1': l1,
  'l-2': l2,
  'l-3': l3,
  'l-4': l4,
  'l-5': l5,
  'l-6': l6,
  'l-7': l7,
  'l-8': l8,
  'l-9': l9,
  about,
  'completed-Guest': completedGuest,
  'completed-User': completedUser,
  'completed-Kompetansepluss': completedKompetansePluss
}

export default modules
